<template>
  <div>
    <div class="additional-content">
      <button @click="sortBy('Montag')">Montag</button>
      <button @click="sortBy('Dienstag')">Dienstag</button>
      <button @click="sortBy('Mittwoch')">Mittwoch</button>
      <button @click="sortBy('Donnerstag')">Donnerstag</button>
      <button @click="sortBy('Freitag')">Freitag</button>
      <button @click="sortBy('Summe Überstunden')">Summe</button>
    </div>
    <div id="hot"></div>
  </div>
</template>

<script>
import PVDataTable from './PVDataTable.vue';

export default {
  name: 'PVDataTableZASumme',
  extends: PVDataTable,
  methods: {
    sortBy(day) {
      if (!this.hotInstance) return;

      const dayColumnIndex = this.columnTitles.indexOf(day);
      const nameColumnIndex = this.columnTitles.indexOf('Name');

      if (dayColumnIndex === -1 || nameColumnIndex === -1) return;

      const plugin = this.hotInstance.getPlugin('multiColumnSorting');
      if (!plugin) return;

      plugin.sort([
        { column: dayColumnIndex, sortOrder: 'desc' },
        { column: nameColumnIndex, sortOrder: 'asc' }
      ]);
    }
  }
};
</script>

<style>
.additional-content {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.additional-content button {
  min-width: 180px;
  min-height: 40px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.additional-content button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.additional-content button:hover {
  background-color: #0056b3;
}

.additional-content button:hover:disabled {
  background-color: #6c757d;
}
</style>